import AssistChip from 'LuxKit/Chips/AssistChip'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import { useCategoryDropdown } from '../../hooks/useDropdownLogic'
import type { ExploreCategory } from 'tripPlanner/pages/trip/Explore/common'

interface Props {
  className?: string
  onCategoryChange?: (category: ExploreCategory) => void
}

function CategoryDropdown({ className, onCategoryChange }: Props) {
  const {
    selectedCategory,
    isDropdownOpen,
    dropdownRef,
    dropdownItems,
    handleDropdownToggle,
    handleDropdownClose,
  } = useCategoryDropdown(onCategoryChange)

  const { icon: Icon } = selectedCategory

  return (
    <div ref={dropdownRef} style={{ position: 'relative' }} className={className}>
      <AssistChip
        variant="outline"
        size="small"
        onClick={handleDropdownToggle}
        endIcon={<LineAngleDownIcon />}
        startIcon={<Icon />}
      >
        {selectedCategory.label}
      </AssistChip>
      <DropdownList
        size="S"
        open={isDropdownOpen}
        onClose={handleDropdownClose}
        triggerRef={dropdownRef}
        anchorRef={dropdownRef}
      >
        {dropdownItems}
      </DropdownList>
    </div>
  )
}

export default CategoryDropdown
